import * as React from 'react';
import GlobalState, { AppState } from 'AppState';

/**
 * state for the app initializer for now
 */
interface AppInitializerState {
	// in case the settings would change in the meantime
	appContext: AppState;
	isInitializing: boolean;
}

/**
 * Component responsible for the initialization of the react app
 */
class AppInitializer extends React.Component<any, AppInitializerState> {
	constructor(props: any) {
		super(props);

		const preloadedState: AppState = GlobalState;

		this.state = {
			appContext: preloadedState,
			isInitializing: true,
		};
	}

	/**
	 * Place to trigger front end initialization
	 */
	public componentDidMount() {
		this.setState({ isInitializing: false }, () => {
			const loaderWrapper = document.getElementById('spinner-wrapper');

			// Remove loader after setting hidden class for transition.
			if (loaderWrapper) {
				loaderWrapper.classList.add('hidden');
			}
		});
	}

	public render() {
		if (this.state.isInitializing) {
			return null;
		} else {
			return <>{this.props.children}</>;
		}
	}
}

export default AppInitializer;
